"use client";

import { useEffect, useState } from "react";
import { useFormState } from "react-dom";
import { login, type LoginState } from "./actions";

const initialState: LoginState = {};

export default function LoginPage() {
  const [state, formAction] = useFormState(login, initialState);
  const [remember, setRemember] = useState(true);
  const [orgValue, setOrgValue] = useState("");
  const [userValue, setUserValue] = useState("");

  useEffect(() => {
    const savedOrg = localStorage.getItem("temple_login_org") || "";
    const savedUser = localStorage.getItem("temple_login_user") || "";
    if (savedOrg || savedUser) {
      setOrgValue(savedOrg);
      setUserValue(savedUser);
    }
  }, []);

  return (
    <div className="flex min-h-screen items-center justify-center bg-[var(--bg)] px-6 py-8">
      <div className="w-full max-w-[1440px]">
        <div className="flex flex-col items-center text-center">
          <p className="text-xs uppercase tracking-[0.4em] text-[var(--muted)]">
            Temple Cloud
          </p>
          <h1 className="title-font mt-2 text-4xl font-semibold tracking-wide">
            宗教機構雲端平台
          </h1>
          <div className="mt-4 h-40 w-full rounded-[28px] border border-black/5 bg-[linear-gradient(140deg,#0f3f3b_0%,#173634_45%,#1d2b2c_100%)] bg-[url('/temple-line.svg')] bg-contain bg-center bg-no-repeat" />
        </div>

        <form
          action={formAction}
          onSubmit={() => {
            if (remember) {
              localStorage.setItem("temple_login_org", orgValue);
              localStorage.setItem("temple_login_user", userValue);
            } else {
              localStorage.removeItem("temple_login_org");
              localStorage.removeItem("temple_login_user");
            }
          }}
          className="mt-6 space-y-3 rounded-[28px] border border-black/5 bg-white p-6 shadow-[var(--shadow)]"
        >
          <label className="block text-sm">
            <span className="text-[var(--muted)]">機構</span>
            <input
              name="org"
              value={orgValue}
              onChange={(event) => setOrgValue(event.target.value)}
              className="mt-2 w-full rounded-xl border border-black/10 bg-white px-4 py-2 text-sm"
              placeholder="輸入機構名稱 (目前不影響登入)"
            />
          </label>
          <label className="block text-sm">
            <span className="text-[var(--muted)]">帳號</span>
            <input
              name="username"
              value={userValue}
              onChange={(event) => setUserValue(event.target.value)}
              className="mt-2 w-full rounded-xl border border-black/10 bg-white px-4 py-2 text-sm"
              placeholder="輸入帳號"
            />
          </label>
          <label className="block text-sm">
            <span className="text-[var(--muted)]">密碼</span>
            <input
              name="password"
              type="password"
              className="mt-2 w-full rounded-xl border border-black/10 bg-white px-4 py-2 text-sm"
              placeholder="輸入密碼"
            />
          </label>
          <label className="block text-sm">
            <span className="text-[var(--muted)]">圖形驗證碼</span>
            <div className="mt-2 flex flex-col gap-3 md:flex-row md:items-center">
              <input
                name="captcha"
                className="w-full flex-1 rounded-xl border border-black/10 bg-white px-4 py-2 text-sm"
                placeholder="輸入驗證碼"
              />
              <div className="flex items-center gap-2 rounded-xl border border-black/10 bg-[#f1f4f3] px-4 py-2 text-xs text-[var(--muted)]">
                <span className="font-semibold text-[var(--accent-ink)]">
                  7208
                </span>
                <span>重新產生</span>
              </div>
            </div>
          </label>
          {state?.error && (
            <p className="rounded-lg bg-red-50 px-3 py-2 text-xs text-red-700">
              {state.error}
            </p>
          )}
          <label className="flex items-center gap-2 text-xs text-[var(--muted)]">
            <input
              type="checkbox"
              checked={remember}
              onChange={(event) => setRemember(event.target.checked)}
            />
            記住機構與帳號（不記住密碼）
          </label>
          <button
            type="submit"
            className="w-full rounded-full bg-[var(--accent)] py-2 text-sm font-semibold text-white"
          >
            確定登入
          </button>
        </form>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-2 text-sm text-[var(--accent-ink)]">
          <span>加入官方帳號</span>
          <span className="inline-flex h-7 w-7 items-center justify-center rounded-full border border-black/10 bg-[#19c75a] text-[10px] font-semibold text-white">
            LINE
          </span>
          <span>聯繫客服專員</span>
        </div>
      </div>
    </div>
  );
}
